var render = function () {
  var _vm = this
  var _h = _vm.$createElement
  var _c = _vm._self._c || _h
  return _c(
    "div",
    {
      staticClass: "task-config-container",
      on: { "tab-click": _vm.handleTabChange },
    },
    [
      _c(
        "el-tabs",
        {
          attrs: { type: "card" },
          model: {
            value: _vm.activeTab,
            callback: function ($$v) {
              _vm.activeTab = $$v
            },
            expression: "activeTab",
          },
        },
        [
          _c(
            "el-tab-pane",
            { attrs: { label: "商品列表", name: "thirdSamList" } },
            [
              _c("thirdSamList", {
                attrs: { refresh: _vm.refresh, activeTab: _vm.activeTab },
                on: {
                  detailUser: _vm.detailUser,
                  handleEdit: _vm.handleEdit,
                  handleCopy: _vm.handleCopy,
                  handleCoupon: _vm.handleCoupon,
                  addAct: _vm.addAct,
                },
              }),
            ],
            1
          ),
          _vm._v(" "),
          _c(
            "el-tab-pane",
            { attrs: { label: "订单明细", name: "orderList" } },
            [
              _c("orderList", {
                attrs: {
                  activeTab: _vm.activeTab,
                  actId: Number(_vm.actId),
                  actTitle: _vm.actTitle,
                },
              }),
            ],
            1
          ),
          _vm._v(" "),
          _c(
            "el-tab-pane",
            { attrs: { label: "优惠券明细", name: "couponList" } },
            [
              _c("couponList", {
                attrs: {
                  activeTab: _vm.activeTab,
                  actId: Number(_vm.actId),
                  actTitle: _vm.actTitle,
                },
              }),
            ],
            1
          ),
          _vm._v(" "),
          _vm.activeTab == "thirdSamAdd"
            ? _c(
                "el-tab-pane",
                { attrs: { label: "添加映射", name: "thirdSamAdd" } },
                [
                  _c("thirdSamAdd", {
                    attrs: {
                      activeTab: _vm.activeTab,
                      actId: String(_vm.actId),
                    },
                    on: { saved: _vm.saved },
                  }),
                ],
                1
              )
            : _vm._e(),
        ],
        1
      ),
    ],
    1
  )
}
var staticRenderFns = []
render._withStripped = true

export { render, staticRenderFns }